import { Button, Paper, Table, TableBody, TableCell, TableRow, TableHead, TableSortLabel, Checkbox, Grid } from "@mui/material"
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { LeasesBasicDetails, LeasesMenuList, LeasesNav } from "../../../elements"
import WetLeaseList from "../components/WetLeaseList";
import NoRecordFound from "../../../../shared_elements/NoRecordFound";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DeletePopUp, STableLoader, Pagination, PageLoader } from "../../../../shared_elements";
import WetLeaseCRU from "../components/WetLeaseCRU";
import { deleteWetLeaseApi, getWetLeaseApi } from "../apiService";
import { checkApiStatus } from "../../../../utils";
import { globalDeleteService, globalGetService } from "../../../../utils/globalApiServices";
import { enqueueSnackbar } from "notistack";
import { ButtonLoader, ShowAttachments } from "../../../../shared_elements/components";
import { useParams } from "react-router-dom";
import { PermissionWrapper } from "../../../../wrappers";
import { RoleBaseAccess } from "../../../../hoc";
import { trackActivity } from "../../../../utils/mixpanel";
import RevisionHistory from "../../../../shared_elements/components/RevisionHistory";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import fileUpload, { getApiResponse } from "../../../../utils/fileUpload";
import { getStorage } from "../../../../shared_elements/actionCreators";
import FileUploadLayout from "../../../../shared_elements/components/FileUploadLayout";
import ModuleWiseRevisionHistory from "../../../../shared_elements/components/ModuleWiseRevisionHistory";
import WetLeaseCardRU from "../components/WetLeaseCardRU";
import CustomTabs from "../../../../shared_elements/components/CustomTabs";
import BackToLeaseList from "../../../elements/BackToLeaseList";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const TABLE_HEIGHT = 'calc(100vh - 290px)';

const WetLeaseHd = ({ onRequestSort, sortConfig, item, bulk, toggleBulkOps, handleItemClicked }) => {
    const createSortHandler = (property, name) => (event) => {
        onRequestSort(event, property);
        handleItemClicked?.(`Table Sorting: ${name}`);
    };
    return (
        <TableHead>
            <TableRow>
                <TableCell className="table-actions-header" sx={{ width: 140, whiteSpace: "nowrap" }}>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "wet_lease", operationType: ['D'] }}>
                        <Checkbox disableRipple color="primary" size="small" onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', item)} checked={item?.length === bulk?.ids?.length && item?.length > 0} />
                    </PermissionWrapper>
                    Action(s)
                </TableCell>
                <TableCell sx={{ minWidth: '100px', whiteSpace: 'nowrap' }}>
                    <TableSortLabel active={sortConfig?.field === "name"}
                        direction={sortConfig?.field === "name" ? sortConfig.direction : "asc"}
                        onClick={createSortHandler("name", "Name")}> Name</TableSortLabel>
                </TableCell>
                <TableCell sx={{ minWidth: '100px', whiteSpace: 'nowrap' }}>
                    <TableSortLabel active={sortConfig?.field === "start_date"}
                        direction={sortConfig?.field === "start_date" ? sortConfig.direction : "asc"}
                        onClick={createSortHandler("start_date", "Start Date")} >Start Date</TableSortLabel>
                </TableCell>

                <TableCell sx={{ minWidth: '100px', whiteSpace: 'nowrap' }}>
                    <TableSortLabel active={sortConfig?.field === "end_date"}
                        direction={sortConfig?.field === "end_date" ? sortConfig.direction : "asc"}
                        onClick={createSortHandler("end_date", "End Date")}>  End Date </TableSortLabel>
                </TableCell>

                <TableCell sx={{ minidth: '100px', whiteSpace: 'nowrap' }}>
                    <TableSortLabel active={sortConfig?.field === "details"}
                        direction={sortConfig?.field === "details" ? sortConfig.direction : "asc"}
                        onClick={createSortHandler("details", "Details")}>  Details </TableSortLabel>
                </TableCell>

                <TableCell sx={{ minWidth: '100px', whiteSpace: 'nowrap' }}>
                    <TableSortLabel active={sortConfig?.field === "remarks"}
                        direction={sortConfig?.field === "remarks" ? sortConfig.direction : "asc"}
                        onClick={createSortHandler("remarks", "Remarks")}>Remarks </TableSortLabel>
                </TableCell>
            </TableRow>
        </TableHead>
    )
}

const WetLease = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const dispatch = useDispatch()
    const { fileUploadDetails } = useSelector((state) => state.leases);
    const { leaseSlug } = useParams();
    const params = { leaseSlug: leaseSlug };
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [addEditWetLease, setAddEditWetLease] = useState({ modal: false, mode: "", data: null })
    const [sortConfig, setSortConfig] = useState({ field: '', direction: '' });
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const [deleteWetLease, setDeleteWetLease] = useState({ modal: false, data: null })
    const [wetLeaseInfo, setWetLeaseInfo] = useState([]);
    const [bulk, setBulk] = useState({ type: '', modal: false, ids: [], title: '' });
    const [uploadFileList, setUploadFileList] = useState({ modal: false, mode: '', data: null })
    const [isExport, seIsExport] = useState(false)
    const [uploadFileProgressData, setUploadFileProgressData] = useState({})
    const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
    const [slug, setSlug] = useState({})
    const [tabIndex, setTabIndex] = useState(0);


    useEffect(() => {
        const uploadedFileData = getApiResponse("wet_lease", slug);
        getWetLeaseList('skeletonLoader', { per_page: 50 });
        trackActivity('Page Viewed', { page_title: 'Wet Lease' })
        setUploadFileProgressData({ uploadedFileData });
    }, []);

    const getWetLeaseList = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(getWetLeaseApi(params, query), {}).then(response => {
            loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
            if (checkApiStatus(response)) {
                setWetLeaseInfo(response?.data?.data)
            }
        });
        dispatch(getStorage({ lease_slug: params?.leaseSlug, module_name: "wet_lease" }))
    }

    const onDeleteWetLease = () => {
        setLoading(true);
        const slugsToDelete = deleteWetLease?.modal && deleteWetLease?.data?.slug ? [deleteWetLease?.data?.slug] : (bulk?.ids || []).map(item => item?.slug);
        globalDeleteService(deleteWetLeaseApi(params), { slugs: slugsToDelete })
        .then(response => {
            if (checkApiStatus(response)) {
                trackActivity('Item Deleted', { page_title: `Delete Wet Lease'`, success_msg: response?.data?.message, item_ids: deleteWetLease?.data || bulk?.ids, response: response?.data })
                setDeleteWetLease({ modal: false, data: null });
                setBulk({ modal: false, ids: [], wrkGrpSlug: '' })
                enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } })
                getWetLeaseList('', { per_page: wetLeaseInfo?.pagination?.per_page });
            } else {
                setLoading(false);
                enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                trackActivity('Item Deleted', { page_title: `Delete Wet Lease'`, error_msg: response?.data?.message, item_ids: deleteWetLease?.data || bulk?.ids, response: response?.data })
            }
        })
    }
    const toggleBulkOps = async (flag, type, item) => {
        try {
            if (type === 'bulk') {
                setBulk({ ...bulk, type: 'bulk', ids: flag ? item : [] })
            }
            else {
                setBulk({ ...bulk, type: "single", ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id) })
            }
        }
        catch (error) {
            console.error("Error fetching data:", error);
        }
    }
    const onRequestSort = (event, key) => {
        let sortQuery = { field: key };
        if (sortConfig.field === key) {
            sortQuery = { ...sortQuery, direction: sortConfig.direction === 'asc' ? 'desc' : 'asc' };
        } else {
            sortQuery = { ...sortQuery, direction: 'asc' };
        }

        setSortConfig(sortQuery);

        getWetLeaseList('', {
            sort_by: sortQuery.field,
            sort: sortQuery.direction,
            page: wetLeaseInfo?.pagination?.current_page || 1,
            per_page: wetLeaseInfo?.pagination?.per_page || 10,
        });
    };

    const onDeletAttachments = (deletdslug) => {
        setUploadFileList({
            ...uploadFileList, data: {
                ...uploadFileList.data, attachments: uploadFileList.data.attachments.filter(item => item.slug !== deletdslug)
            }
        })
        getWetLeaseList('', { per_page: wetLeaseInfo?.pagination?.per_page });
    }

    const handleExport = () => {
        let query = { export: true }
        if (sortConfig?.direction && sortConfig?.field) {
            query = {
                ...query,
                sort: sortConfig?.direction,
                sort_by: sortConfig?.field
            }
        }
        seIsExport(true);
        globalGetService(getWetLeaseApi(params, query)).then((response) => {
            if (checkApiStatus(response)) {
                enqueueSnackbar(
                    response?.data.message,
                    { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }
                );
                seIsExport(false);
            }
        })
    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: 'Wet Lease', page_type: page_type, })
    }

    const openAddItemModal = () => {
        setAddEditWetLease({ modal: true, mode: "add", data: { name: "", start_date: null, end_date: null, details: "", remarks: "" } });
        handleItemClicked('Add Item button')
    };

    const handleUpload = async (slug, mode) => {
        setSlug({ slug: slug })
        await fileUpload({
            attachments: fileUploadDetails.attachments,
            module_name: "wet_lease",
            slug: slug,
            query: { record_action_type: mode },
            onStart: () => setLoading(true),
            onComplete: () => setLoading(false),
            onProgress: ({ progressRefs, attachments, response }) => {
                setUploadFileProgressData({ progressRefs, attachments, response });
            },
            onSuccess: (success_msg) => {
                enqueueSnackbar(success_msg, {
                    variant: "success",
                    anchorOrigin: { vertical: "top", horizontal: "right" }
                });
                getWetLeaseList("", { per_page: wetLeaseInfo?.pagination?.per_page || 50 });
            },
            onError: (err) => {
                enqueueSnackbar(`${err?.message}` || "Error while uploading files", {
                    variant: "error",
                    anchorOrigin: { vertical: "top", horizontal: "right" }
                });
            }
        });
        setSlug({})
    };

    return (
        <>
            <LeasesBasicDetails />
            <Paper className='lease-details-section section-overflow lease-module-paper' elevation={0}>
                <LeasesNav type="basic" />
                <div className='lease-details-content contnet-overflow'>
                    <Paper square className="responsive-paper">
                        <Grid container className="responsive-grid" alignItems='end'>
                            <Grid item size={{ md: 12, xs: 12 }} className="menu-container">
                                <LeasesMenuList btnText="Wet Lease" type="basic" />
                            </Grid>
                             <Grid item size={{ md: 6, xs: 12 }} className="menu-container">
                                <BackToLeaseList />
                            </Grid>
                            <Grid item size={{ md: 6, xs: 12 }}>
                                <ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding: '0px', float: 'right',minHeight:'35px' }}>
                                    <li className="lease-mobile-button revision-history"><ModuleWiseRevisionHistory ViewGlobalHistory={() => { setRevisionHistory({ modal: true, mode: '', data: { slug: params?.leaseSlug, type: "global" } }); handleItemClicked('Global Revision HistoryIcon') }} /> </li>
                                    {tabIndex === 0 &&
                                        <>
                                            {
                                                bulk?.type && bulk.ids.length ?
                                                    <>
                                                        <li className='lease-mobile-button'>
                                                            <Button onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '' }); handleItemClicked('Bulk Delete Cancel button') }} color="primary" variant="outlined" size="small">Cancel</Button>
                                                        </li>
                                                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "wet_lease", operationType: ['D'] }}>
                                                            <li className='lease-mobile-button'>
                                                                <Button onClick={() => { setBulk({ ...bulk, modal: true, title: "Delete" }); handleItemClicked('Bulk Delete button') }} variant="outlined" size="small" sx={{ backgroundColor: "#f50057", borderColor: "#f50057", color: "#fff" }}>{`Delete (${bulk?.ids?.length})`}</Button>
                                                            </li>
                                                        </PermissionWrapper>
                                                    </> : null
                                            }

                                        </>}
                                    {wetLeaseInfo?.list?.length > 0 ? <li className='lease-mobile-button'> <Button startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} onClick={() => { handleExport(); handleItemClicked('Export button') }} variant="outlined" size='small' className='btn-primary action-btn-start-icon'> Export </Button> </li> : null}
                                    {tabIndex === 0 ?
                                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "wet_lease", operationType: ['C'] }}>
                                            <li className='lease-mobile-button'>
                                                <Button startIcon={<AddOutlinedIcon />} className='action-btn-start-icon' size="small" variant="contained" color="primary" onClick={openAddItemModal}>Add Wet Lease</Button>
                                            </li>
                                        </PermissionWrapper>
                                    : null}
                                </ul>
                            </Grid>
                            <Grid item size={{ md: 12 }} mt='5px' sx={{ display: { xs: "none", sm: "block" } }}>
                                <CustomTabs
                                    tabsList={['Wet lease', 'Wet lease Config']}
                                    onChange={(e, val) => { setTabIndex(val); handleItemClicked(`Tab Selected: ${val === 1 ? 'Wet lease Config' : 'Wet lease'}`) }}
                                    value={tabIndex}
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                    {isMobile ? <WetLeaseCardRU /> : tabIndex === 1 ? <WetLeaseCardRU /> : null}
                    {(isMobile || tabIndex === 0) ?
                        <Paper className='lease-detail-table table-tab-container lease-module-paper' elevation={0} sx={{ display: 'flex', flexDirection: 'column', maxHeight: TABLE_HEIGHT, height: wetLeaseInfo?.list?.length > 0 ? `${TABLE_HEIGHT} !important` : 'auto !important' }}>
                            <div style={{ flex: '1 1 auto', overflow: 'auto', minHeight: 0 }}>
                                {skeletonLoader ? <STableLoader count={4} rowCount={12} /> : (
                                    <Table className='mui-table-format' stickyHeader>
                                        <WetLeaseHd onRequestSort={onRequestSort} sortConfig={sortConfig} item={wetLeaseInfo?.list} bulk={bulk} toggleBulkOps={toggleBulkOps} handleItemClicked={handleItemClicked} />
                                        <TableBody>
                                            {wetLeaseInfo?.list?.length > 0 && wetLeaseInfo?.list?.map((item, index) => {
                                                const uploadedFileData = getApiResponse("Parties", item?.slug);
                                                return (
                                                    <WetLeaseList
                                                        slug={slug?.slug}
                                                        uploadedFileData={uploadedFileData}
                                                        uploadFileProgressData={uploadFileProgressData}
                                                        viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                                                        item={item}
                                                        key={index}
                                                        viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                                                        viewFile={() => setUploadFileList({ modal: true, mode: 'file', data: item })}
                                                        onView={() => setAddEditWetLease({ modal: true, mode: "view", data: item })}
                                                        onDelete={() => {
                                                            setDeleteWetLease({ modal: true, data: item });
                                                            setBulk({modal: false, ids: [item], type: ''});
                                                        }}
                                                        onEdit={() => setAddEditWetLease({ modal: true, mode: "edit", data: item })}
                                                        bulk={bulk}
                                                        toggleBulkOps={toggleBulkOps}
                                                    />
                                                )
                                            })}
                                        </TableBody>
                                    </Table>
                                )}
                                {!skeletonLoader && !wetLeaseInfo?.list?.length && <NoRecordFound />}
                            </div>
                            <Paper square>
                                <Pagination
                                    pagination={wetLeaseInfo?.pagination} onPageChange={(event, newPage) => { const pageNum = newPage + 1; getWetLeaseList("Pageloader", { page: pageNum, per_page: wetLeaseInfo?.pagination?.per_page, ...(sortConfig?.sort_by ? { sort_by: sortConfig.sort_by, sort: sortConfig.sort, } : {}), }); }} onRowsPerPageChange={(e) => { const perPage = parseInt(e.target.value, 10); getWetLeaseList("Pageloader", { page: 1, per_page: perPage, ...(sortConfig?.sort_by ? { sort_by: sortConfig.sort_by, sort: sortConfig.sort, } : {}), }); }}
                                />
                            </Paper>
                        </Paper> : null}
                </div>
            </Paper>
            {
                uploadFileList?.modal ?
                    <ShowAttachments
                        url='delete-attachment'
                        moduleName="Wet Lease"
                        attachmentsData={uploadFileList}
                        getResponseBack={onDeletAttachments}
                        toggleModalFn={() => setUploadFileList({ modal: false, mode: '', data: null })}
                        onViewDisabled={addEditWetLease?.mode === 'view' || uploadFileList?.mode === 'view'}
                        permissionKey="wet_lease"
                    /> : null
            }
            {
                addEditWetLease.modal ?
                    <WetLeaseCRU
                        fileUpload={handleUpload}
                        params={params}
                        modeType={addEditWetLease?.mode}
                        addEditWetLease={addEditWetLease}
                        getResponseBack={() => {getWetLeaseList('', { per_page: wetLeaseInfo?.pagination?.per_page }); setBulk({modal: false, ids: [], type: '', title: '' })}}
                        onToggleModal={() => setAddEditWetLease({ modal: false, mode: "", data: null })}
                        onOpenAttachments={() => setUploadFileList({ modal: true, data: addEditWetLease.data, mode: 'view' })}
                    /> : null

            }
            {
                deleteWetLease.modal ?
                    <DeletePopUp
                        modal={deleteWetLease.modal}
                        title={"Delete Wet Lease"}
                        content={"Are you sure, you want to delete"}
                        onToggleModal={() => setDeleteWetLease({ modal: false, data: null })}
                        onDeleteRecords={() => onDeleteWetLease()}
                    /> : null
            }
            {
                bulk.modal ?
                    <DeletePopUp
                        modal={bulk.modal}
                        title={`Delete ${bulk?.ids?.length && bulk.ids.length === (wetLeaseInfo?.list?.length || 0) ? "All Wet Lease" : "Selected Wet Lease"}`}
                        content={`Are you sure, you want to delete ${bulk.ids.length > 1 ? 'these ' : 'this '} record?`}
                        onDeleteRecords={() => onDeleteWetLease()}
                        onToggleModal={() => setBulk({ modal: false, type: '', ids: [] })}
                    /> : null
            }

            {
                revisionHistory.modal &&
                <RevisionHistory
                    moduleName={"wet_lease"}
                    revisionHistory={revisionHistory}
                    onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
                />
            }
            <FileUploadLayout
                uploadFileStatus={uploadFileStatus}
                open={uploadFileStatus?.modal}
                setUploadFileStatus={setUploadFileStatus}
                uploadFileProgressData={uploadFileProgressData}
                progressRefs={uploadFileProgressData?.progressRefs}
                attachments={uploadFileProgressData?.attachments}
                onDownloadComplete={() => setSlug({})}
            />
            {isLoading ? <PageLoader /> : null}
        </>
    )
}

export default RoleBaseAccess(WetLease, { application: 'lease_revamp', feature: 'wet_lease', operationType: ['R'] });
